<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "restaureringer",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "Left2MiddleRight",
          leftImage: "/images/restaureringer/1/left.jpg",
          leftImageHeight: 350,
          middleTopImage: "/images/restaureringer/1/middle-top.jpg",
          middleTopImageHeight: 150,
          middleBottomImage: "/images/restaureringer/1/middle-bottom.jpg",
          middleBottomImageHeight: 150,
          rightImage: "/images/restaureringer/1/right.jpg",
          rightImageHeight: 350,
          leftText: "AMTMANDSBOLIG HJØRRING HOVEDRESTAURERING 2011-13",
          rightText: ""
        },
        {
          id: 2,
          type: "LeftRight",
          leftImage: "/images/restaureringer/2/left.jpg",
          leftImageHeight: 270,
          rightImage: "/images/restaureringer/2/right.jpg",
          rightImageHeight: 270,
          leftText: "AALBORG TOLDKAMMER HOVEDRESTAURERING 2004-06",
          rightText: ""
        },
        {
          id: 3,
          type: "Left2Middle2Right",
          leftImage: "/images/restaureringer/3/left.jpg",
          leftImageHeight: 370,
          middleTopImage: "/images/restaureringer/3/middle-top.jpg",
          middleTopImageHeight: 200,
          middleBottomImage: "/images/restaureringer/3/middle-bottom.jpg",
          middleBottomImageHeight: 200,
          rightTopImage: "/images/restaureringer/3/right-top.jpg",
          rightTopImageHeight: 200,
          rightBottomImage: "/images/restaureringer/3/right-bottom.jpg",
          rightBottomImageHeight: 200,
          leftText: "BISPEGÅRD RIBE HOVEDRESTAURERING 2014",
          rightText: ""
        },
        {
          id: 4,
          type: "LeftMiddle2Right",
          leftImage: "/images/restaureringer/4/left.jpg",
          leftImageHeight: 420,
          middleImage: "/images/restaureringer/4/middle.jpg",
          middleImageHeight: 420,
          rightTopImage: "/images/restaureringer/4/right-top.jpg",
          rightTopImageHeight: 213,
          rightBottomImage: "/images/restaureringer/4/right-bottom.jpg",
          rightBottomImageHeight: 213,
          leftText: "LODBERG FYR NATIONALPARK THY HOVEDRESTAURERING 2013-2016",
          rightText: ""
        },
        {
          if: 5,
          type: "2LeftRight",
          leftTopImage: "/images/restaureringer/5/left-top.jpg",
          leftTopImageHeight: 270,
          leftBottomImage: "/images/restaureringer/5/left-bottom.png",
          leftBottomImageHeight: 150,
          rightImage: "/images/restaureringer/5/right.jpg",
          rightImageHeight: 430,
          leftText:
            "HALD HOVEDGÅRD OMBYGNINGER SAL OG BIBLIOTEK I TÅRNET 1995-2014",
          rightText: ""
        },
        {
          id: 6,
          type: "2TopBottom",
          topLeftImage: "/images/restaureringer/6/top-left.jpg",
          topLeftImageHeight: 220,
          topRightImage: "/images/restaureringer/6/top-right.jpg",
          topRightImageHeight: 220,
          bottomImage: "/images/restaureringer/6/bottom.jpg",
          bottomImageHeight: 200,
          leftText: "KALØ GODS HOVEDISTANDSÆTTELSE 1996-2016",
          rightText: ""
        },
        {
          id: 7,
          type: "2LeftRight",
          leftTopImage: "/images/restaureringer/7/left-top.jpg",
          leftTopImageHeight: 210,
          leftBottomImage: "/images/restaureringer/7/left-bottom.jpg",
          leftBottomImageHeight: 210,
          rightImage: "/images/restaureringer/7/right.jpg",
          rightImageHeight: 450,
          leftText: "KALØ GODS JAGTSLOTTET RESTAURERINGER 1996-2016",
          rightText: ""
        },
        {
          id: 8,
          type: "Left2Right",
          leftImage: "/images/restaureringer/8/left.jpg",
          leftImageHeight: 440,
          rightTopImage: "/images/restaureringer/8/right-top.jpg",
          rightTopImageHeight: 280,
          rightBottomImage: "/images/restaureringer/8/right-bottom.jpg",
          rightBottomImageHeight: 140,
          leftText:
            "NØRREHALD FEMMØLLER IND OG UDVENDIG HOVEDRESTAURERING 2004-2006",
          rightText: ""
        }
      ]
    };
  }
};
</script>
